import { render, staticRenderFns } from "./TolButton.vue?vue&type=template&id=d457e456&scoped=true&"
import script from "./TolButton.vue?vue&type=script&lang=js&"
export * from "./TolButton.vue?vue&type=script&lang=js&"
import style0 from "./TolButton.vue?vue&type=style&index=0&id=d457e456&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d457e456",
  null
  
)

export default component.exports